var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sale-items",
    style: {
      backgroundColor: _vm.backgroundColor
    }
  }, [_c('div', {
    staticClass: "sale-items__bg sale-items__bg_desktop"
  }, [_vm.backgroundDesktop ? _c('img', {
    staticClass: "sale-items__bg__img",
    attrs: {
      "src": _vm.backgroundDesktop
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sale-items__bg sale-items__bg_mobile"
  }, [_vm.backgroundMobile ? _c('img', {
    staticClass: "sale-items__bg__img",
    attrs: {
      "src": _vm.backgroundMobile
    }
  }) : _vm._e()]), _vm._v(" "), _c('GGGroup', {
    staticClass: "sale-items__content",
    attrs: {
      "prop": _vm.data.template.prop,
      "data": _vm.data.dataSource.data
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('div', {
          staticClass: "sale-items__slider sale-items__slider_desktop"
        }, [_c('GGRowSlider', {
          attrs: {
            "list": _vm.data.dataSource.data.product || [],
            "offset-between-elements": 15
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref) {
              var _el$price, _el$price2, _el$price3, _el$price4;

              var el = _ref.el;
              return [_c('GGLink', {
                staticClass: "item-card__link",
                attrs: {
                  "to": el.path
                }
              }, [_c('div', {
                staticClass: "item-card"
              }, [(_el$price = el.price) !== null && _el$price !== void 0 && _el$price.discount.value ? _c('GGDiscountMarker', {
                staticClass: "item-card__discount",
                attrs: {
                  "price": (_el$price2 = el.price) === null || _el$price2 === void 0 ? void 0 : _el$price2.discount.value,
                  "discount": (_el$price3 = el.price) === null || _el$price3 === void 0 ? void 0 : _el$price3.common.value
                }
              }) : _vm._e(), _vm._v(" "), _c('div', {
                staticClass: "item-card__image-wrapper"
              }, [_c('img', {
                staticClass: "item-card__image",
                attrs: {
                  "src": el.image.x1,
                  "srcset": ((el.image.x2) + " 2x"),
                  "alt": el.name
                }
              })]), _vm._v(" "), (_el$price4 = el.price) !== null && _el$price4 !== void 0 && _el$price4.common.value ? _c('GGPrice', {
                staticClass: "item-card__price",
                attrs: {
                  "price": el.price
                }
              }) : _vm._e()], 1)])];
            }
          }])
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "sale-items__slider sale-items__slider_mobile"
        }, [_c('GGRowSlider', {
          attrs: {
            "list": _vm.data.dataSource.data.product || [],
            "offset-between-elements": 5
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var _el$price5, _el$price6, _el$price7, _el$price8;

              var el = _ref2.el;
              return [_c('GGLink', {
                staticClass: "item-card__link",
                attrs: {
                  "to": el.path
                }
              }, [_c('div', {
                staticClass: "item-card"
              }, [(_el$price5 = el.price) !== null && _el$price5 !== void 0 && _el$price5.discount.value ? _c('GGDiscountMarker', {
                staticClass: "item-card__discount",
                attrs: {
                  "price": (_el$price6 = el.price) === null || _el$price6 === void 0 ? void 0 : _el$price6.discount.value,
                  "discount": (_el$price7 = el.price) === null || _el$price7 === void 0 ? void 0 : _el$price7.common.value
                }
              }) : _vm._e(), _vm._v(" "), _c('div', {
                staticClass: "item-card__image-wrapper"
              }, [_c('img', {
                staticClass: "item-card__image",
                attrs: {
                  "src": el.image.x1,
                  "srcset": ((el.image.x2) + " 2x"),
                  "alt": el.name
                }
              })]), _vm._v(" "), (_el$price8 = el.price) !== null && _el$price8 !== void 0 && _el$price8.common.value ? _c('GGPrice', {
                staticClass: "item-card__price",
                attrs: {
                  "price": el.price
                }
              }) : _vm._e()], 1)])];
            }
          }])
        })], 1)];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }